webpackJsonp([35783957827783],{

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(23);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(30);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(29);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(69);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(68);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\""; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\""; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA3MiA3MiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNzIgNzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojRUQyMDI0O3N0cm9rZS13aWR0aDoxLjU7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQo8L3N0eWxlPgo8Zz4KCTxyZWN0IHg9IjEuNyIgeT0iMzguNyIgY2xhc3M9InN0MCIgd2lkdGg9IjE1IiBoZWlnaHQ9IjE1Ii8+Cgk8cmVjdCB4PSIyMy4xIiB5PSIzOC43IiBjbGFzcz0ic3QwIiB3aWR0aD0iMTUiIGhlaWdodD0iMTUiLz4KCTxyZWN0IHg9IjQ0LjUiIHk9IjM4LjciIGNsYXNzPSJzdDAiIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIvPgoJPHJlY3QgeD0iMTIiIHk9IjE4LjIiIGNsYXNzPSJzdDAiIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIvPgoJPHJlY3QgeD0iMzMuMyIgeT0iMTguMiIgY2xhc3M9InN0MCIgd2lkdGg9IjE1IiBoZWlnaHQ9IjE1Ii8+Cgk8cmVjdCB4PSI1NC43IiB5PSIxOC4yIiBjbGFzcz0ic3QwIiB3aWR0aD0iMTUiIGhlaWdodD0iMTUiLz4KCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSIyMy4xIiB5MT0iMjUuOCIgeDI9IjM3LjEiIHkyPSIyNS44Ii8+Cgk8bGluZSBjbGFzcz0ic3QwIiB4MT0iNDQuNSIgeTE9IjI1LjgiIHgyPSI1OC41IiB5Mj0iMjUuOCIvPgoJPGxpbmUgY2xhc3M9InN0MCIgeDE9IjEyLjkiIHkxPSI0Ni4yIiB4Mj0iMjYuOSIgeTI9IjQ2LjIiLz4KCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSIzNC4zIiB5MT0iNDYuMiIgeDI9IjQ4LjMiIHkyPSI0Ni4yIi8+Cgk8cG9seWxpbmUgY2xhc3M9InN0MCIgcG9pbnRzPSI2Ny4yLDMzLjMgNjcuMiw0Ni4yIDU1LjQsNDYuMiAJIi8+CjwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA3MiA3MiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNzIgNzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojRUQyMDI0O3N0cm9rZS13aWR0aDoxLjU7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQo8L3N0eWxlPgo8cmVjdCB4PSI0LjYiIHk9IjEwLjIiIGNsYXNzPSJzdDAiIHdpZHRoPSI2Mi45IiBoZWlnaHQ9IjM4LjEiLz4KPGxpbmUgY2xhc3M9InN0MCIgeDE9IjM2LjEiIHkxPSI0OC40IiB4Mj0iMzYuMSIgeTI9IjU4LjYiLz4KPGxpbmUgY2xhc3M9InN0MCIgeDE9IjE5IiB5MT0iNTguNiIgeDI9IjUzLjEiIHkyPSI1OC42Ii8+Cjxwb2x5bGluZSBjbGFzcz0ic3QwIiBwb2ludHM9IjU2LjYsMjAuMyAzNCwzNy45IDIyLjcsMjkuMyAxNC4xLDM4LjkgIi8+Cjxwb2x5bGluZSBjbGFzcz0ic3QwIiBwb2ludHM9IjUzLjgsMTkuOCA1Ny40LDE5LjYgNTYuNCwyMyAiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA3MiAxNDQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDcyIDE0NDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtjbGlwLXBhdGg6dXJsKCNTVkdJRF8yXyk7ZmlsbDpub25lO3N0cm9rZTojRUQyMjI0O3N0cm9rZS13aWR0aDozO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojRUQyMDI0O3N0cm9rZS13aWR0aDozO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGc+Cgk8ZGVmcz4KCQk8cmVjdCBpZD0iU1ZHSURfMV8iIHg9Ii01MjAiIHk9Ii0xODU2IiB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIzODQ4Ii8+Cgk8L2RlZnM+Cgk8Y2xpcFBhdGggaWQ9IlNWR0lEXzJfIj4KCQk8dXNlIHhsaW5rOmhyZWY9IiNTVkdJRF8xXyIgIHN0eWxlPSJvdmVyZmxvdzp2aXNpYmxlOyIvPgoJPC9jbGlwUGF0aD4KCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSItOCIgeTE9Ii01NzAuNSIgeDI9Ii04IiB5Mj0iLTY5MCIvPgo8L2c+CjxsaW5lIGNsYXNzPSJzdDEiIHgxPSIzNiIgeTE9IjEwLjciIHgyPSIzNiIgeTI9IjEzMC4yIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA3MiA3MiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNzIgNzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojRUQyMDI0O3N0cm9rZS13aWR0aDoxLjU7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQo8L3N0eWxlPgo8Zz4KCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSIxMC44IiB5MT0iMzAuOCIgeDI9IjEwLjgiIHkyPSIzOC42Ii8+Cgk8bGluZSBjbGFzcz0ic3QwIiB4MT0iMTYiIHkxPSIyNi45IiB4Mj0iMTYiIHkyPSI0Mi42Ii8+Cgk8bGluZSBjbGFzcz0ic3QwIiB4MT0iMjEuMSIgeTE9IjE5LjkiIHgyPSIyMS4xIiB5Mj0iNDkuNSIvPgoJPGxpbmUgY2xhc3M9InN0MCIgeDE9IjI2LjMiIHkxPSIyNi45IiB4Mj0iMjYuMyIgeTI9IjQyLjYiLz4KCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSIzMS40IiB5MT0iMzAuOCIgeDI9IjMxLjQiIHkyPSIzOC42Ii8+Cgk8bGluZSBjbGFzcz0ic3QwIiB4MT0iMzYuNiIgeTE9IjMzLjQiIHgyPSIzNi42IiB5Mj0iMzYiLz4KCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSI1LjciIHkxPSIzMy40IiB4Mj0iNS43IiB5Mj0iMzYiLz4KCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSI0MS43IiB5MT0iMzIuNSIgeDI9IjQxLjciIHkyPSIzNyIvPgoJPGxpbmUgY2xhc3M9InN0MCIgeDE9IjQ2LjkiIHkxPSIyOSIgeDI9IjQ2LjkiIHkyPSI0MC40Ii8+Cgk8bGluZSBjbGFzcz0ic3QwIiB4MT0iNTIiIHkxPSIyNC4zIiB4Mj0iNTIiIHkyPSI0NS4xIi8+Cgk8bGluZSBjbGFzcz0ic3QwIiB4MT0iNTcuMiIgeTE9IjI5IiB4Mj0iNTcuMiIgeTI9IjQwLjQiLz4KCTxsaW5lIGNsYXNzPSJzdDAiIHgxPSI2Mi4zIiB5MT0iMzIuNSIgeDI9IjYyLjMiIHkyPSIzNyIvPgoJPGxpbmUgY2xhc3M9InN0MCIgeDE9IjY3LjUiIHkxPSIzNC4xIiB4Mj0iNjcuNSIgeTI9IjM1LjQiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ButtonGone = exports.Button = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    background-color: transparent;\n    border-color: ', ';\n    border-radius: 4px;\n    border-width: 3px;\n    border-style: ', ';\n    cursor: pointer;\n    display: inline-block;\n    font-size: 0.9em;\n    color: ', ';\n    font-weight: ', ';\n    font-family: ', ';\n    height: 2.75em;\n    letter-spacing: 0.125em;\n    line-height: 2.75em;\n    padding: 0 2em;\n    text-align: center;\n    text-decoration: none;\n    text-indent: 0.125em;\n    text-transform: uppercase;\n    white-space: nowrap;\n    &:hover {\n        color: ', ';\n        border-color: ', ';\n    }\n'], ['\n    background-color: transparent;\n    border-color: ', ';\n    border-radius: 4px;\n    border-width: 3px;\n    border-style: ', ';\n    cursor: pointer;\n    display: inline-block;\n    font-size: 0.9em;\n    color: ', ';\n    font-weight: ', ';\n    font-family: ', ';\n    height: 2.75em;\n    letter-spacing: 0.125em;\n    line-height: 2.75em;\n    padding: 0 2em;\n    text-align: center;\n    text-decoration: none;\n    text-indent: 0.125em;\n    text-transform: uppercase;\n    white-space: nowrap;\n    &:hover {\n        color: ', ';\n        border-color: ', ';\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n@media all and (max-width: 750px) {\n    display: none;\n}\n'], ['\n@media all and (max-width: 750px) {\n    display: none;\n}\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Button = _styledComponents2.default.button(_templateObject, function (props) {
	    return props.inverse ? props.theme.font_light : props.theme.font_dark;
	}, function (props) {
	    return props.unstyled ? 'none' : 'solid';
	}, function (props) {
	    return props.inverse ? props.theme.font_light : props.theme.font_dark;
	}, function (props) {
	    return props.theme.font_weight_bold;
	}, function (props) {
	    return props.font == 'body' ? props.theme.font_body : props.theme.font_header;
	}, function (props) {
	    return props.hover ? props.hover : props.theme.accent;
	}, function (props) {
	    return props.hover ? props.hover : props.theme.accent;
	});
	var ButtonGone = Button.extend(_templateObject2);
	exports.Button = Button;
	exports.ButtonGone = ButtonGone;

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.VDivider = exports.HDivider = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    width: 1.5em;\n    height: 0.05em;\n    background-color: red;\n    margin: auto;\n    margin-top: 25px;\n    margin-bottom: 25px;    \n'], ['\n    width: 1.5em;\n    height: 0.05em;\n    background-color: red;\n    margin: auto;\n    margin-top: 25px;\n    margin-bottom: 25px;    \n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    width: 0.15em;\n    height: 5em;\n    background-color: red;\n    margin: auto;\n'], ['\n    width: 0.15em;\n    height: 5em;\n    background-color: red;\n    margin: auto;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Membran_Divider = __webpack_require__(489);
	
	var _Membran_Divider2 = _interopRequireDefault(_Membran_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var HDivider = _styledComponents2.default.div(_templateObject);
	var VDivider = _styledComponents2.default.div(_templateObject2);
	
	exports.HDivider = HDivider;
	exports.VDivider = VDivider;

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Hero = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    z-index: 0;\n    padding: 12em 0 6em 0;\n    font-family: ', ';    \n    background-color: ', ';\n    color: ', ';\n    background-attachment: fixed;\n    background-image: \n        url(', ');\n    background-position: top left;\n    background-size: cover;\n    overflow: hidden;\n    position: relative;\n    text-align: ', ';\n    .background {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        display: block;\n        object-fit: cover;\n\n    }\n    \n    h1 {\n        font-size: 3em;\n        line-height: 1em;\n    }\n    p {\n        font-size: 1.15em;\n        margin: (', ' * 0.5) 0 0 0;\n    }\n    .inner {\n        opacity: 1;\n        position: relative;\n\n        .actions {\n            opacity: 1;\n        }\n    }\n    .actions {\n        margin: calc(', ' * 1.25) 0 0 0;\n    }\n    /* Media queries */\n    @media (max-width: 1680px){\n        padding: 14em 0 calc(', '*2.5) 0;        \n    }\n    @media (max-width: 1280px){\n        padding: 10em 0 calc(', '*2.4) 0;                \n        br {\n            display: inline;\n        }\n    }\n    @media (max-width: 980px){\n        font-size: 0.75em;\n        padding: 8em 0 calc(', '*2.25) 0;                \n    }\n    @media (max-width: 736px){    \n        padding: 6em 0 calc(', '*2) 0;\n        h1 {\n            font-size: 2.5em;\n        }\n    }\n    @media (max-width: 480px) {\n            padding: 6em 0 calc(', '*2) 0;    \n    }\n    @media (max-width: 360px) {\n        padding: 4em 0 calc(', '*2) 0;\n    }\n'], ['\n    z-index: 0;\n    padding: 12em 0 6em 0;\n    font-family: ', ';    \n    background-color: ', ';\n    color: ', ';\n    background-attachment: fixed;\n    background-image: \n        url(', ');\n    background-position: top left;\n    background-size: cover;\n    overflow: hidden;\n    position: relative;\n    text-align: ', ';\n    .background {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        display: block;\n        object-fit: cover;\n\n    }\n    \n    h1 {\n        font-size: 3em;\n        line-height: 1em;\n    }\n    p {\n        font-size: 1.15em;\n        margin: (', ' * 0.5) 0 0 0;\n    }\n    .inner {\n        opacity: 1;\n        position: relative;\n\n        .actions {\n            opacity: 1;\n        }\n    }\n    .actions {\n        margin: calc(', ' * 1.25) 0 0 0;\n    }\n    /* Media queries */\n    @media (max-width: 1680px){\n        padding: 14em 0 calc(', '*2.5) 0;        \n    }\n    @media (max-width: 1280px){\n        padding: 10em 0 calc(', '*2.4) 0;                \n        br {\n            display: inline;\n        }\n    }\n    @media (max-width: 980px){\n        font-size: 0.75em;\n        padding: 8em 0 calc(', '*2.25) 0;                \n    }\n    @media (max-width: 736px){    \n        padding: 6em 0 calc(', '*2) 0;\n        h1 {\n            font-size: 2.5em;\n        }\n    }\n    @media (max-width: 480px) {\n            padding: 6em 0 calc(', '*2) 0;    \n    }\n    @media (max-width: 360px) {\n        padding: 4em 0 calc(', '*2) 0;\n    }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Hero = _styledComponents2.default.header(_templateObject, function (props) {
	    return props.theme.font_header;
	}, function (props) {
	    return props.dark ? props.theme.bg_dark : props.theme.bg_light;
	}, function (props) {
	    return props.dark ? props.theme.font_light : props.theme.font_dark;
	}, function (props) {
	    return props.image;
	}, function (props) {
	    return props.centered ? 'center' : 'left';
	}, function (props) {
	    return props.theme.element_margin;
	}, function (props) {
	    return props.theme.element_margin;
	}, function (props) {
	    return props.theme.element_margin;
	}, function (props) {
	    return props.theme.element_margin;
	}, function (props) {
	    return props.theme.element_margin;
	}, function (props) {
	    return props.theme.element_margin;
	}, function (props) {
	    return props.theme.element_margin;
	}, function (props) {
	    return props.theme.element_margin;
	});
	
	exports.Hero = Hero;

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(64);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(59);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _button = __webpack_require__(47);
	
	var _footer = __webpack_require__(48);
	
	var _grid = __webpack_require__(27);
	
	var _header = __webpack_require__(28);
	
	var _hero = __webpack_require__(49);
	
	var _theme = __webpack_require__(51);
	
	var _navbar = __webpack_require__(67);
	
	var _segment = __webpack_require__(50);
	
	var _wrapper = __webpack_require__(52);
	
	var _divider = __webpack_require__(215);
	
	var _Membran_Music = __webpack_require__(492);
	
	var _Membran_Music2 = _interopRequireDefault(_Membran_Music);
	
	var _Membran_Business = __webpack_require__(488);
	
	var _Membran_Business2 = _interopRequireDefault(_Membran_Business);
	
	var _Membran_Blockchain = __webpack_require__(487);
	
	var _Membran_Blockchain2 = _interopRequireDefault(_Membran_Blockchain);
	
	var _Membran_Harvest = __webpack_require__(490);
	
	var _Membran_Harvest2 = _interopRequireDefault(_Membran_Harvest);
	
	var _Membran_Hyperstate = __webpack_require__(491);
	
	var _Membran_Hyperstate2 = _interopRequireDefault(_Membran_Hyperstate);
	
	var _Membran_TrebleKey = __webpack_require__(493);
	
	var _Membran_TrebleKey2 = _interopRequireDefault(_Membran_TrebleKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import "../assets/styles/labs.scss";
	
	var IndexPage = function IndexPage(props) {
	    return _react2.default.createElement(
	        _styledComponents.ThemeProvider,
	        { theme: _theme.LabsTheme },
	        _react2.default.createElement(
	            _wrapper.Wrapper,
	            null,
	            _react2.default.createElement(_reactHelmet2.default, { title: 'Home' }),
	            _react2.default.createElement(
	                _segment.Segment,
	                { style: { height: 0, padding: '0 0 0 0', margin: 0, zIndex: 999 } },
	                _react2.default.createElement(
	                    _navbar.Navbar,
	                    { fade: true },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#top' },
	                            _react2.default.createElement(
	                                _header.Accent,
	                                null,
	                                'membran'
	                            ),
	                            ' labs'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { style: { fontSize: '0.75em', fontWeight: 'bold' }, href: '#services' },
	                        'SERVICES'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { style: { fontSize: '0.75em', fontWeight: 'bold' }, href: '#projects' },
	                        'PROJECTS'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { style: { fontSize: '0.75em', fontWeight: 'bold' }, href: '#about' },
	                        'ABOUT US'
	                    )
	                )
	            ),
	            _react2.default.createElement('div', { id: 'top' }),
	            _react2.default.createElement(
	                _hero.Hero,
	                { dark: true, centered: true },
	                _react2.default.createElement(_gatsbyImage2.default, {
	                    css: { top: 0, left: 0, right: 0, zIndex: -1 },
	                    style: { position: 'absolute' },
	                    title: 'Header image',
	                    alt: 'computer workstation',
	                    sizes: props.data.header.sizes,
	                    className: 'background'
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        _grid.Grid,
	                        null,
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '12' },
	                            _react2.default.createElement(
	                                'h1',
	                                { style: { letterSpacing: 2, fontSize: '2.5em' } },
	                                _react2.default.createElement(
	                                    'strong',
	                                    null,
	                                    'M',
	                                    _react2.default.createElement(
	                                        _header.Accent,
	                                        null,
	                                        'U'
	                                    ),
	                                    'SIC MEETS BL',
	                                    _react2.default.createElement(
	                                        _header.Accent,
	                                        null,
	                                        'O'
	                                    ),
	                                    'CKCHAIN'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { style: { fontWeight: '300' } },
	                                'helping to usher music into the next digital age'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _segment.Segment,
	                { centered: true },
	                _react2.default.createElement(
	                    'div',
	                    { style: {
	                            zIndex: 1,
	                            position: 'absolute',
	                            top: '0px',
	                            left: '50%',
	                            transform: 'translate(-50%, -50%)',
	                            margin: 'auto'
	                        } },
	                    _react2.default.createElement(_divider.VDivider, { style: { top: '-50px' } })
	                ),
	                _react2.default.createElement(
	                    _grid.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '12' },
	                        _react2.default.createElement(
	                            _header.Header,
	                            null,
	                            _react2.default.createElement(
	                                'h2',
	                                { style: { letterSpacing: 2 } },
	                                'MUSIC FIRST'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '12' },
	                        _react2.default.createElement(
	                            'h4',
	                            { style: { fontWeight: 500 } },
	                            _react2.default.createElement(
	                                _header.Accent,
	                                null,
	                                'We are a music company with a tech team, ',
	                                _react2.default.createElement('br', null),
	                                ' not the other way around.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'With extensive expertise in the music industry, we understand the challenges and problems you face, because we face them too. Our team is already researching, building, and testing a number of solutions to make it easier, faster, and more efficient for you to get paid and rewarded for your music!'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '12' },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Whether you\u2019re a performing artist or writer, a label or publisher, a manager or promoter, or just interested in music and how blockchain technology is likely to change everything; we are here to help educate, test, and develop solutions with you.'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _segment.Segment,
	                { centered: true },
	                _react2.default.createElement('div', { id: 'services', style: { position: 'relative', top: '-100px' } }),
	                _react2.default.createElement(_divider.VDivider, { style: { position: 'relative', top: '-50px' } }),
	                _react2.default.createElement(
	                    _grid.Grid,
	                    null,
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '12' },
	                        _react2.default.createElement(
	                            _header.Header,
	                            null,
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'SERVICES'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '4' },
	                        _react2.default.createElement('img', { style: { width: '50%', maxWidth: '200px' }, src: _Membran_Music2.default }),
	                        _react2.default.createElement(
	                            _header.Header,
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                { style: { letterSpacing: '2.4' } },
	                                'MUSIC'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Helping navigate the rapidly changing music industry'
	                        ),
	                        _react2.default.createElement(_divider.HDivider, null),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Clarifying music rights, registrations, & the flow of music revenues'
	                        ),
	                        _react2.default.createElement(_divider.HDivider, null),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Providing access to global artist services'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '4' },
	                        _react2.default.createElement('img', { style: { width: '50%', maxWidth: '200px' }, src: _Membran_Business2.default }),
	                        _react2.default.createElement(
	                            _header.Header,
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                { style: { letterSpacing: '2.4' } },
	                                'BUSINESS'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Insights for your business and the music industry'
	                        ),
	                        _react2.default.createElement(_divider.HDivider, null),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Positioning you to take advantage of blockchain technology'
	                        ),
	                        _react2.default.createElement(_divider.HDivider, null),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Building your release strategy and navigating the global music market'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '4' },
	                        _react2.default.createElement('img', { style: { width: '50%', maxWidth: '200px' }, src: _Membran_Blockchain2.default }),
	                        _react2.default.createElement(
	                            _header.Header,
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                { style: { letterSpacing: '2.4' } },
	                                'BLOCKCHAIN'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Educating about blockchain and its use cases'
	                        ),
	                        _react2.default.createElement(_divider.HDivider, null),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Giving you insights and turning your ideas into reality'
	                        ),
	                        _react2.default.createElement(_divider.HDivider, null),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Developing real world projects'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _segment.Segment,
	                { centered: true, dark: true, style: { height: 300 } },
	                _react2.default.createElement('div', { id: 'contact', style: { position: 'relative', top: '-100px' } }),
	                _react2.default.createElement(_gatsbyImage2.default, { css: { zIndex: -1 },
	                    style: { position: 'absolute', objectFit: 'cover' },
	                    title: 'Background 01',
	                    alt: 'computer workstation',
	                    sizes: props.data.pic01.sizes,
	                    className: 'background'
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginTop: 50, position: 'relative' } },
	                    _react2.default.createElement(
	                        _grid.Grid,
	                        null,
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '12' },
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'mailto://canada@membran.net', style: { borderBottom: 'none', fontSize: '1em', fontWeight: '700', padding: 10 } },
	                                _react2.default.createElement(
	                                    _button.Button,
	                                    { inverse: true, style: { borderRadius: 0, borderWidth: 4, height: 65 } },
	                                    'CONTACT US'
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _segment.Segment,
	                { centered: true },
	                _react2.default.createElement('div', { id: 'projects', style: { position: 'relative', top: '-100px' } }),
	                _react2.default.createElement(
	                    'div',
	                    { style: {
	                            zIndex: 1,
	                            position: 'absolute',
	                            top: '0px',
	                            left: '50%',
	                            transform: 'translate(-50%, -50%)',
	                            margin: 'auto'
	                        } },
	                    _react2.default.createElement(_divider.VDivider, { style: { top: '-50px' } })
	                ),
	                _react2.default.createElement(
	                    _grid.Grid,
	                    { style: { paddingTop: 25 } },
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '12' },
	                        _react2.default.createElement(
	                            _header.Header,
	                            null,
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'PROJECTS'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '4' },
	                        _react2.default.createElement('img', { style: { width: '50%', maxWidth: '200px' }, src: _Membran_TrebleKey2.default, alt: 'treblekey icon' }),
	                        _react2.default.createElement(
	                            _header.Header,
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'TREBLEKEY'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'An events management platform that gives control and clarity to event creators and security to fans.'
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/treblekey#top', style: { borderBottom: 'none', fontSize: '0.6em', fontWeight: '700', padding: 10 } },
	                            _react2.default.createElement(
	                                _button.Button,
	                                { style: { borderRadius: 0, borderWidth: 4, height: 65 } },
	                                'LEARN MORE'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '4' },
	                        _react2.default.createElement('img', { style: { width: '50%', maxWidth: '200px' }, src: _Membran_Hyperstate2.default, alt: 'hyperstate icon' }),
	                        _react2.default.createElement(
	                            _header.Header,
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'HYPERSTATE'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Generating instantaneous royalty reporting, from Spotify to the Artist, and everyone in between, at the same time.'
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/hyperstate#top', style: { borderBottom: 'none', fontSize: '0.6em', fontWeight: '700', padding: 10 } },
	                            _react2.default.createElement(
	                                _button.Button,
	                                { style: { borderRadius: 0, borderWidth: 4, height: 65 } },
	                                'LEARN MORE'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _grid.Column,
	                        { span: '4' },
	                        _react2.default.createElement('img', { style: { width: '50%', maxWidth: '200px' }, src: _Membran_Harvest2.default, alt: 'harvest icon' }),
	                        _react2.default.createElement(
	                            _header.Header,
	                            null,
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'HARVEST'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '"Air Miles for Artists". A fun way to reward artists based on actual fan engagement, not based on the streaming provider, or their contract split. Tradeable, collectable, and valuable.'
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/harvest#top', style: { borderBottom: 'none', fontSize: '0.6em', fontWeight: '700', padding: 10 } },
	                            _react2.default.createElement(
	                                _button.Button,
	                                { style: { borderRadius: 0, borderWidth: 4, height: 65 } },
	                                'LEARN MORE'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _segment.Segment,
	                { centered: true },
	                _react2.default.createElement('div', { id: 'about', style: { position: 'relative', top: '-100px' } }),
	                _react2.default.createElement(_divider.VDivider, { style: { position: 'relative', top: '-50px' } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        _grid.Grid,
	                        null,
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '12' },
	                            _react2.default.createElement(
	                                _header.Header,
	                                null,
	                                _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    'ABOUT US'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _grid.Column,
	                            { span: '12' },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Membran Labs was born from the Membran Group of Companies, out of a mutual concern for the current state of the music industry, and an interest in the latest technologies that show promise to help solve some of the most important problems.'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _footer.Footer,
	                { dark: true },
	                _react2.default.createElement('div', { alt: 'This div is here for spacing.' }),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        { style: { listStyle: 'none', textAlign: 'center' } },
	                        _react2.default.createElement(
	                            'h2',
	                            { style: { textAlign: 'center' } },
	                            'CONTACT'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'mailto:canada@membran.net' },
	                                'EMAIL US'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { style: { listStyle: 'none', textAlign: 'center' } },
	                        _react2.default.createElement(
	                            'h2',
	                            { style: { textAlign: 'center' } },
	                            'PODCAST'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://anchor.fm/fault-tolerant', target: '_blank' },
	                                'Fault Tolerant'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://anchor.fm/offkey', target: '_blank' },
	                                'OffKey'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://medium.com/membran-labs', target: '_blank' },
	                                'Show Notes'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: '/studio_rates.pdf', target: '_blank' },
	                                'Studio'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        { style: { listStyle: 'none', textAlign: 'center' } },
	                        _react2.default.createElement(
	                            'h2',
	                            { style: { textAlign: 'center' } },
	                            'EXPLORE'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'http://www.membran.net' },
	                                'MEMBRAN.NET'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _header.Accent,
	                                null,
	                                'MEMBRAN LABS'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: '/treblekey' },
	                                'TREBLEKEY'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'harvest/' },
	                                'HARVEST'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'hyperstate/' },
	                                'HYPERSTATE'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f4f741ab1cab4b1ca1c0.js